import type * as Stitches from '@stitches/react';

const WebkitScrollbarY: Stitches.CSS = {
  '&::-webkit-scrollbar': {
    width: '0.4rem',
    backgroundColor: '$blue100',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '$blue300',
  },
};

const WebkitScrollbarX: Stitches.CSS = {
  '&::-webkit-scrollbar': {
    height: '0.4rem',
    backgroundColor: '$blue100',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '$blue300',
  },
};

export const utilsStyles = {
  WebkitScrollbarX,
  WebkitScrollbarY,
};
